import type { Maybe } from '@vrplatform/utils';
import type { listing as Listing } from '@vrplatform/graphql';

export const getListingName = (
  listing: Maybe<Listing>,
  opts?: { allowEmpty?: boolean }
) => {
  const name = listing?.name?.trim() || '';
  const title = listing?.title?.trim() || '';
  const uniqueRef = listing?.uniqueRef?.trim() || '';
  const listingConnection = listing?.connections()?.[0];
  const connectionName = listingConnection?.name?.trim() || '';

  return (
    title ||
    name ||
    uniqueRef ||
    connectionName ||
    (opts?.allowEmpty ? '' : 'No name')
  );
};
